import {
  Paper, FormControl, InputLabel, Select, MenuItem, TextField, Button, CircularProgress,
} from '@mui/material';

const Filters = ({ proposalType, setProposalType, dateFrom, setDateFrom, dateTo, setDateTo, groupBy, setGroupBy, loading, onApply }) => (
  <Paper sx={{ p: 2, mb: 3, display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
    <FormControl size="small" sx={{ minWidth: 160 }}>
      <InputLabel>Contract Type</InputLabel>
      <Select value={proposalType} label="Contract Type" onChange={(e) => setProposalType(e.target.value)}>
        <MenuItem value="">All</MenuItem>
        <MenuItem value="Installation">Installation</MenuItem>
        <MenuItem value="Service">Service</MenuItem>
      </Select>
    </FormControl>
    <TextField size="small" type="date" label="From" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} InputLabelProps={{ shrink: true }} />
    <TextField size="small" type="date" label="To" value={dateTo} onChange={(e) => setDateTo(e.target.value)} InputLabelProps={{ shrink: true }} />
    <FormControl size="small" sx={{ minWidth: 120 }}>
      <InputLabel>Group By</InputLabel>
      <Select value={groupBy} label="Group By" onChange={(e) => setGroupBy(e.target.value)}>
        <MenuItem value="day">Day</MenuItem>
        <MenuItem value="week">Week</MenuItem>
        <MenuItem value="month">Month</MenuItem>
      </Select>
    </FormControl>
    <Button variant="contained" onClick={onApply} disabled={loading} sx={{ bgcolor: '#0d3c61', '&:hover': { bgcolor: '#0a2d4a' } }}>
      {loading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Apply'}
    </Button>
  </Paper>
);

export default Filters;
